import { render } from "./SocketComponent.vue?vue&type=template&id=f91fea18&scoped=true"
import script from "./SocketComponent.vue?vue&type=script&lang=js"
export * from "./SocketComponent.vue?vue&type=script&lang=js"

import "./SocketComponent.vue?vue&type=style&index=0&id=f91fea18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91fea18"]])

export default __exports__